export default function AppLoader() {
	return (
		<main className='loader__wrapper'>
			<div className='loader-5 center'>
				<span></span>
			</div>
		</main>
	);
}
